import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd';
import { RegisterService } from '../../../services/register.service';
import { TranslateService } from '@ngx-translate/core';
import { PasswordService } from '../../../services/password.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {

  modifyForm: FormGroup;

  constructor(
    private router: Router,
    private modal: NzModalService,
    private fb: FormBuilder,
    private psdService: PasswordService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.modifyForm = this.fb.group({
      oldPassword: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(16)]],
      newPassword: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(16), this.samePasswordValidator]],
      checkPassword: [null, [Validators.required, this.confirmationValidator]],
    });
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.modifyForm.controls['newPassword'].value) {
      return { confirm: true, error: true };
    }
  }

  samePasswordValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value === this.modifyForm.controls['oldPassword'].value) {
      return { same: true, error: true };
    }
  }

  updateConfirmValidator() {
    /** wait for refresh value */
    setTimeout(() => {
      this.modifyForm.controls['checkPassword'].updateValueAndValidity();
    });
  }

  getFormControl(name) {
    return this.modifyForm.controls[name];
  }

  _submitForm() {
    for (const i in this.modifyForm.controls) {
      if (this.modifyForm.controls.hasOwnProperty(i)) {
        this.modifyForm.controls[i].markAsDirty();
      }
    }

    if (this.modifyForm.valid) {
      const val = this.modifyForm.value;
      const body = {
        oldPassword: val.oldPassword,
        newPassword: val.newPassword
      };

      this.psdService.modifyPassword(body).toPromise().then(res => {
        this.modal.success({
          title: this.translate.instant('common.success'),
          content: this.translate.instant('user.modify-password-success')
        }).on('onHidden', () => {
          setTimeout(() => {
            this.router.navigate(['/user']);
          }, 300);
        });
      }, err => {
        this.modal.error({
          title: this.translate.instant('common.error'),
          content: err
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/userCenter/password/password.component.ts